import React from 'react'
import { Link } from '@at/design-system-elements'
import { StyledSaveSearchModalText } from './save-search-form.styles'

export const AlreadySavedThisSearch = () => {
    return (
        <div>
            <StyledSaveSearchModalText as="p">You have already saved this search.</StyledSaveSearchModalText>
            <Link href="/secure/saved-searches" rel="external">
                See your saved searches
            </Link>
        </div>
    )
}
